class BulkInvoiceItemTypesUploadPageTransform {
  constructor() {
    "ngInject";
  }
}

export default BulkInvoiceItemTypesUploadPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.transforms.js